<template>
  <fragment>
    <AppNavBarBottom
      v-if="$vuetify.breakpoint.mdAndDown" />
    <AppNavBarSide
      v-if="$vuetify.breakpoint.lgAndUp" />
  </fragment>
</template>
<script>
export default {
  name: 'AppNavBar',
  components: {
    AppNavBarSide: () => import('./AppNavBarSide'),
    AppNavBarBottom: () => import('./AppNavBarBottom'),
  },
};
</script>